import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen" }

import TopBar from '@/components/TopBar/TopBar.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopBar),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})